import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapActions, mapGetters } from "vuex";
import { required, numeric, alpha, maxLength, minLength, email } from "vuelidate/lib/validators";
import { onlyLetters, onlyEmail, noSpecialChars } from "~/validators";
import { stepForm, onlyNumbersMixin, onlyLettersMixin, documentNumberAndTypeFormMixin } from "~/mixins";
import loader from "../modals/loader";

export default {
  mixins: [stepForm, onlyNumbersMixin, onlyLettersMixin
  // documentNumberAndTypeFormMixin
  ],
  components: {
    loader: loader
  },
  data: function data() {
    var _$store$state$affilia = this.$store.state.affiliations.form.installationSchedule,
        serviceHours = _$store$state$affilia.serviceHours,
        name = _$store$state$affilia.name,
        phone = _$store$state$affilia.phone,
        paternalLastname = _$store$state$affilia.paternalLastname,
        maternalLastname = _$store$state$affilia.maternalLastname,
        email = _$store$state$affilia.email,
        documentNumber = _$store$state$affilia.documentNumber,
        documentType = _$store$state$affilia.documentType;
    var user = this.$store.state.affiliations.form.virtual.user;

    return {
      // multiple_options: serviceHours,
      dataLegal: user.usingLegalRepresentativeData,
      name: user.firstName || name || null,
      paternalLastname: user.paternalName || paternalLastname || null,
      maternalLastname: user.maternalName || maternalLastname || null,
      number: user.phone || phone || null,
      email: user.email || email || null,
      // documentNumber,
      // documentType,
      sending: false
      // responsiveOptions: [
      //     'De 10 am a 2 pm',
      //     'De 2 pm a 6 pm',
      //     'De 8 pm a 12 am'
      // ]
    };
  },

  validations: {
    name: {
      required: required,
      onlyLetters: onlyLetters("name")
    },
    number: {
      required: required,
      numeric: numeric,
      maxLength: maxLength(9),
      minLength: minLength(9)
    },
    // multiple_options: {
    //     required
    // },
    paternalLastname: {
      required: required,
      onlyLetters: onlyLetters("name")
    },
    maternalLastname: {
      required: required,
      onlyLetters: onlyLetters("name")
    },
    // documentNumber: {
    //     required,
    //     numeric,
    //     minLength : minLength(this.maxLengthDocumentNumber),
    // },
    // documentType: {
    //     required
    // },
    email: {
      required: required,
      // email,
      noSpecialChars: noSpecialChars('noSpecialChars'),
      emailValidate: onlyEmail('emailValidate')
    }
  },
  methods: _extends({}, mapMutations({
    setStepNumber: "affiliations/form/setStepNumber"
  }), {
    back: function back() {
      if (this.$store.state["affiliations"].form.corresponsaliaData.header.agent.CodeAgent != 'Z02') {
        this.setStepNumber(this.currentStep - 2);
      } else {
        this.setStepNumber(this.currentStep - 1);
      }
    },
    submit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var timestamp, _ref2, existeCorreo, responseServer, _email, serverIp;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                this.sending = true;
                this.$refs.loaderModal.showLoader();
                _context.prev = 2;


                // servicio para verificar correo
                timestamp = Date.now();
                _context.next = 6;
                return this.$store.dispatch("affiliations/form/getVerifiedEmail", {
                  transaccionId: timestamp,
                  correo: this.email.toLowerCase()
                });

              case 6:
                _ref2 = _context.sent;
                existeCorreo = _ref2.existeCorreo;
                responseServer = _ref2.responseServer;
                _email = _ref2.email;
                serverIp = _ref2.serverIp;

                if (!(responseServer === 'Error')) {
                  _context.next = 17;
                  break;
                }

                this.$swal('Error', 'Error en el servicio. Vuelva a intentarlo mas tarde.', 'error');
                this.sending = false;
                this.$refs.loaderModal.closeLoader();
                _context.next = 30;
                break;

              case 17:
                if (!existeCorreo) {
                  _context.next = 27;
                  break;
                }

                console.log('Entra acaaaaaa');
                this.$v.$touch();

                if (!this.$v.invalid) {
                  _context.next = 22;
                  break;
                }

                return _context.abrupt("return");

              case 22:
                this.sending = true;

                _context.next = 25;
                return this.$store.dispatch("affiliations/form/saveInstallationSchedule", {
                  //serviceHours: this.multiple_options,
                  name: this.name,
                  phone: this.number,
                  paternalLastname: this.paternalLastname,
                  maternalLastname: this.maternalLastname,
                  email: this.email
                });

              case 25:
                _context.next = 30;
                break;

              case 27:
                this.$swal('Aviso', "No existe el correo " + this.email + ", ingresar uno correcto.", 'warning');
                this.sending = false;
                this.$refs.loaderModal.closeLoader();

              case 30:
                _context.next = 38;
                break;

              case 32:
                _context.prev = 32;
                _context.t0 = _context["catch"](2);

                console.log(_context.t0);
                this.$swal('Aviso', "El correo ingresado tiene formato incorrecto.", 'warning');
                this.sending = false;
                this.$refs.loaderModal.closeLoader();
                // this.$controlMessage(error);

              case 38:
                this.sending = false;
                this.$refs.loaderModal.closeLoader();

              case 40:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 32]]);
      }));

      function submit() {
        return _ref.apply(this, arguments);
      }

      return submit;
    }(),
    loadLegalRepresentativeData: function loadLegalRepresentativeData() {
      var response = this.$store.state["affiliations"].form.legalRepresentativeData;
      if (this.dataLegal == true) {
        this.name = response.firstName;
        this.paternalLastname = response.paternalName;
        this.maternalLastname = response.maternalName;
        this.number = response.cellPhone;
        this.email = response.email;
      } else {
        this.name = "";
        this.paternalLastname = "";
        this.maternalLastname = "";
        this.number = "";
        this.email = "";
        this.$v.$reset();
      }
    }
  }),
  computed: _extends({}, mapGetters({
    currentStep: "affiliations/form/currentStep"
  }), {
    contactErrorMessage: function contactErrorMessage() {
      var errors = [];
      if (!this.$v.number.$dirty) return errors;
      !this.$v.number.required && errors.push("Debes ingresar un teléfono");
      !this.$v.number.numeric && errors.push("Debes ingresar solo números");
      !this.$v.number.minLength && errors.push("Tiene que ser 9 dígitos");
      return errors;
    },
    nameErrorMessage: function nameErrorMessage() {
      var errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push("Ingresa tus nombres");
      !this.$v.name.onlyLetters && errors.push("Ingrese sólo letras");
      return errors;
    },
    paternalLastnameErrorMessage: function paternalLastnameErrorMessage() {
      var errors = [];
      if (!this.$v.paternalLastname.$dirty) return errors;
      !this.$v.paternalLastname.required && errors.push("Ingresa tu apellido paterno");
      !this.$v.paternalLastname.onlyLetters && errors.push("Ingrese sólo letras");
      return errors;
    },
    maternalLastnameErrorMessage: function maternalLastnameErrorMessage() {
      var errors = [];
      if (!this.$v.maternalLastname.$dirty) return errors;
      !this.$v.maternalLastname.required && errors.push("Ingresa tu apellido materno");
      !this.$v.maternalLastname.onlyLetters && errors.push("Ingrese sólo letras");
      return errors;
    },
    emailErrorMessage: function emailErrorMessage() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push("Debes ingresar un correo");
      // !this.$v.email.email && errors.push("No es un correo válido");
      !this.$v.email.noSpecialChars && errors.push('No puede ingresar caracteres espciales'), !this.$v.email.emailValidate && errors.push('Ingrese un email válido');
      return errors;
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/installation-schedule.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/installation-schedule.vue
// module chunks = 0 1 2 3